import styled from 'styled-components';

export const LoaderMain = styled.div`
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  border: 0.25rem solid rgb(189, 181, 181);
  border-top-color: black;
  animation: spin 0.2s infinite linear;
`;
